import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { clearStoredAuthSession } from '@/lib/authSession';
import { trackLogoutCompleted } from '@/lib/analytics/trackers/auth';
import { showErrorToast, showSuccessToast } from '@/utils/toast-utils';

export const useLogout = () => {
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const navigate = useNavigate();

  const handleLogout = async () => {
    // Show confirmation dialog
    const confirmed = window.confirm('Are you sure you want to log out?');
    
    if (!confirmed) {
      return;
    }

    setIsLoggingOut(true);
    
    try {
      trackLogoutCompleted();
      // Clear all auth data
      clearStoredAuthSession();
      
      // Show success toast
      showSuccessToast("Logged out successfully", "You have been logged out of your account.");
      
      // Navigate to landing page
      navigate('/');
    } catch (error) {
      console.error('Logout error:', error);
      showErrorToast(error, "Logout failed");
    } finally {
      setIsLoggingOut(false);
    }
  };

  return {
    handleLogout,
    isLoggingOut
  };
};
